import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SanMarino: Country = {
    identifier: "SanMarino",
    name: "San Marino",
    countryCode: "SM",
    group: CountryGroup.EUROPE,
    isUNMember: true,
    flag: "🇸🇲",
    svgPath: "m 509.93475,326.2634 -0.165,0.029 -0.083,-0.158 0.124,-0.185 0.176,-0.029 0.031,0.143 z",
}
